import {React} from "react";

/**
 * Page to show when user don't have enough permission to view this page
 * @return {any}
 */
export default function PermissionDenied() {
  return (<>Permission Denied</>);
}
